module.exports = __webpack_public_path__ + "static/media/brandCards.3572a42c.png";